
<div class="container-fluid pt-0 pl-0 pr-0">    
    <div *ngIf="!modal" class="row">
        <div class="col-md-2 col-sm-4 col-4">
          <app-personimage [bigimg]="true" [enableChange]="false" [personId]="person.personId"></app-personimage>
        </div>
        <div class="col pl-3">
            <div class="row">
                <div class="col">
                    <p class="mb-0 fw-400 pb-2">{{person.fullname}}</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="mb-0 font-weight-lighter text-muted">{{ 'person.email' | trans }}</p>
                    <p class="mb-0 pb-1">{{person.email}}</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                  <p class="mb-0 font-weight-lighter text-muted">{{ 'person.phone' | trans }}</p>
                    <p class="mb-0 pb-1">{{person.phone}}</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                  <p class="mb-0 font-weight-lighter text-muted">{{ 'person.instantmessaging' | trans }}</p>
                    <p class="mb-0 pb-1">{{person.im}}</p>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!modal" class="row mt-0 pl-3">
        <div class="col">
          <p class="mb-0 font-weight-lighter text-muted">{{ 'person.description' | trans }}</p>
            <p class="mb-0">{{person.professionaldesc}}</p>
        </div>
    </div>
  </div>
  <div *ngIf="modal" class="p-3">
    <div class="form-group mb-2">
      <label class="font-weight-light text-muted f-13 mb-0" for="name">{{ 'person.name' | trans }}</label>
      <input  [(ngModel)]="person.fullname" type="text" class="form-control" id="name" aria-describedby="nameHelp">
      <small id="nameHelp" class="form-text text-muted">{{ 'person.namehelp' | trans }}</small>
    </div>
    <div class="form-group mb-2">
      <label class="font-weight-light text-muted f-13 mb-0" for="im">IM</label>
      <input  [(ngModel)]="person.im" type="text" class="form-control" id="im" aria-describedby="imHelp">
      <small id="imHelp" class="form-text text-muted">{{ 'person.imhelp' | trans }}</small>
    </div>
    <div class="form-group mb-2">
      <label class="font-weight-light text-muted f-13 mb-0" for="phone">{{ 'person.phone' | trans }}</label>
      <input  [(ngModel)]="person.phone" type="text" class="form-control" id="phone" aria-describedby="phoneHelp">
      <small id="phoneHelp" class="form-text text-muted">{{ 'person.phonehelp' | trans }}</small>
    </div>
    <div class="form-group mb-2">
      <label class="font-weight-light text-muted f-13 mb-0" for="email">{{ 'person.email' | trans }}</label>
      <input  [(ngModel)]="person.email" type="email" class="form-control" id="email" aria-describedby="emailHelp">
      <small id="emailHelp" class="form-text text-muted">{{ 'person.emailhelp' | trans }}</small>
    </div>
    <div *ngIf="orgList.length > 0" class="form-group mb-2">
      <label for="orgselect" class="font-weight-light text-muted f-13 mb-0">{{ 'person.defaultorganization' | trans }}</label>
      <select [(ngModel)]="person.defaultorg" class="form-control" id="orgselect" aria-describedby="orgselectHelp">
        <option *ngFor="let org of orgList; let i = index" value="{{org.organizationId}}">{{org.organization}}</option>
      </select>
      <small id="orgselectHelp" class="form-text text-muted">{{ 'person.defaultorganizationhelp' | trans }}</small>
    </div>
    <div class="form-group mb-2">
      <label for="description" class="font-weight-light text-muted f-13 mb-0">{{ 'person.description' | trans }}</label>
      <textarea  [(ngModel)]="person.professionaldesc" class="form-control" id="description" rows="3" aria-describedby="descriptionHelp"></textarea>
      <small id="descriptionHelp" class="form-text text-muted">{{ 'person.descriptionhelp' | trans }}</small>
    </div>
  </div>






